import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

/**
 * Checks whether a given string or number does NOT satisfy a given regular expression.
 * TODO: consider adding protection against evil regex {@link https://owasp.org/www-community/attacks/Regular_expression_Denial_of_Service_-_ReDoS}
 */
export class NotMatch extends Operator<string | number> {
  constructor() {
    super(LOGIC_OPERATOR.MATCH, z.string().or(z.number().finite()))
  }

  evaluate(
    factValue: string | number,
    comparisonValue: ComparisonValue
  ): boolean {
    const comparisonRegex = z.string().parse(comparisonValue)

    return new RegExp(comparisonRegex).test(String(factValue)) === false
  }
}
